<template>
    <div class="last-snapshots">
        <div v-if="loading">
            <div class="columns">
                <div class="column is-full has-text-centered">
                    <img src="/loader-dark.svg">
                </div>
            </div>
        </div>
        <div v-if="!hasSnapshots && loadedOnce && !loading" style="padding-top: 4px;">
            <div class="columns">
                <div class="column is-3" style="padding: 14px 15px 11px 15px !important">
                    <img width="110px" style="opacity: 0.7" :src="require('@/assets/img/server.svg')" />
                </div>
                <div class="column is-9">
                    <b>Ooops!</b>
                    <br>
                    Looks like you don't have any snapshots. After you will start using Weap, in order to have a better overview, your recent snapshots will be visible here.
                </div>
            </div>
        </div>
        <div v-if="hasSnapshots && !loading">
            <div class="last-snapshot" :key="snapshot.type + '-' + snapshot.id" v-for="snapshot in snapshots">
                <div class="columns">
                    <div>
                        <div class="snapshot-icon tooltip" :data-tooltip="snapshotStatusTooltip(snapshot)" :class="{ 
                            'snapshot-in-progress-icon': snapshotInProgress(snapshot), 
                            'snapshot-completed-icon': snapshotCompleted(snapshot),
                            'snapshot-failed-icon': snapshotFailed(snapshot) || snapshotProviderDeleted(snapshot),
                            'snapshot-expired-icon': snapshotExpired(snapshot)
                            }">
                            <font-awesome-icon v-show="snapshotInProgress(snapshot)" :icon="['far', 'circle']"/>
                            <font-awesome-icon v-show="snapshotCompleted(snapshot)" :icon="['far', 'check-circle']"/>
                            <font-awesome-icon v-show="snapshotFailed(snapshot)" :icon="['far', 'times-circle']"/>
                            <font-awesome-icon v-show="snapshotExpired(snapshot)" :icon="['far', 'clock']"/>
                            <font-awesome-icon v-show="snapshotProviderDeleted(snapshot)" :icon="['fas', 'trash-alt']"/>
                        </div>
                    </div>
                    <div class="snapshot-title">
                        <router-link :to="{ name: routeName(snapshot), params: {id: snapshot.resource_id} }">{{ snapshotName(snapshot) }}</router-link>
                    </div>
                    <div class="snapshot-size"><div class="tag is-light" style="width: 68px; color: #868e96">{{ snapshotSize(snapshot) }}</div></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Api from '@/api';

export default {
    data() {
        return {
            snapshots: [],
            loading: true,
            loadedOnce: false,
        }
    },

    mounted() {
        this.getSnapshots();
    },

    methods: {
        getSnapshots() {
            Api().get('users/current/snapshots-and-backups')
                .then((response) => {
                    this.loadedOnce = true;
                    this.snapshots = response.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        snapshotInProgress(snapshot) {
            return snapshot.status == 'in_progress';
        },

        snapshotFailed(snapshot) {
            return snapshot.status == 'errored';
        },

        snapshotCompleted(snapshot) {
            return snapshot.status == 'completed';
        },

        snapshotExpired(snapshot) {
            return snapshot.status == 'expired';
        },

        snapshotProviderDeleted(snapshot) {
            return snapshot.status == 'provider_deleted' || snapshot.status == 'deleted';
        },

        snapshotName(snapshot) {
            if (!snapshot.name) {
                return '-';
            }

            if (snapshot.name.length > 70) {
                return snapshot.name.slice(0, 70) + '...';
            }

            return snapshot.name;
        },

        snapshotSize(snapshot) {
            if (this.snapshotFailed(snapshot) || this.snapshotInProgress(snapshot)) {
                return 'N/A';
            }

            if (typeof snapshot.size_amount === 'undefined' || typeof snapshot.size_unit === 'undefined') {
                return 'N/A';
            }

            if (snapshot.size_amount === null) {
                return 'N/A';
            }

            return snapshot.size_amount + snapshot.size_unit;
        },

        snapshotStatusTooltip(snapshot) {
            if (this.snapshotInProgress(snapshot)) {
                if (snapshot.type == 'backup') {
                    return 'Backup in progress.';
                }
                return 'Snapshot in progress.';
            }

            if (this.snapshotCompleted(snapshot)) {
                if (snapshot.type == 'backup') {
                    return 'Backup completed.';
                }
                return 'Snapshot completed.';
            }

            if (this.snapshotExpired(snapshot)) {
                if (snapshot.type == 'backup') {
                    return 'Backup expired.';
                }
                return 'Snapshot expired.';
            }
            
            if (this.snapshotProviderDeleted(snapshot)) {
                if (snapshot.type == 'backup') {
                    return 'Backup deleted.';
                }
                return 'Snapshot deleted from the provider.';
            }

            if (this.snapshotFailed(snapshot)) {
                if (snapshot.type == 'backup') {
                    return 'Backup failed.';
                }
                return 'Snapshot failed.';
            }
        },

        routeName(snapshot) {
            if (snapshot.type == 'backup') {
                return 'showDatabase';
            }

            return 'showCloudlet';
        },
    },

    computed: {
        hasSnapshots() {
            return this.snapshots.length > 0;
        },
    },
}
</script>
